module.exports = __webpack_public_path__ + "static/img/t3-2.0d71144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t3-2.png
// module id = 9kJs
// module chunks = 1